import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/auth.store.js';

export default function ProtectedRoute({ children, roles }) {
  const location = useLocation();
  const { user, accessToken } = useAuthStore();
  if (!accessToken || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (roles && roles.length > 0 && !roles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }
  return children;
}
